<template>

  <SiteLayout>

    <b-container fluid class="my-5">
      <b-row>
        <b-col lg="8" class="header-custom-rounded">
          <div class="bg-primary header-custom-rounded h-100 p-2">
            <m-single-contents-wrapper content-link="header-banner-1">
              <b-container slot-scope="{content}">
                <b-row align-h="center" align-v="center">
                  <b-col class="order-md-1" lg="6">
                    <div class="">
                      <h1 class="text-dark">{{ content.title }}</h1>
                      <p class="text-dark" v-html="content.abstraction"></p>
                    </div>
                    <div>
                      <m-a :href="{name:'SinglePage',params:{slug:content.slug}}">
                        <m-bt503 class="header-button-rounded">
                          <template #p-1>
                            <b-icon-arrow-left-circle/>
                          </template>
                          <template #p-2>برای مشاهده کلیک کنید.</template>
                          <template #p-3>
                            <b-icon-arrow-left-circle/>
                          </template>
                        </m-bt503>
                      </m-a>
                    </div>
                  </b-col>
                  <b-col class="order-md-2" lg="6">
                    <img :src="content.thumbnail" :alt="content.title"
                         class="col-lg-12 py-5 header-banner-image">
                  </b-col>
                </b-row>
              </b-container>
            </m-single-contents-wrapper>
          </div>
        </b-col>

        <b-col lg="4">
          <b-row>
            <m-single-contents-wrapper content-link="header-banner-2">
              <b-col slot-scope="{content}" lg="12" class="my-3">
                <m-c306 :image="content.thumbnail" :alt="content.title" class="bg-primary header-banner-rounded py-3">
                  <template #p-1>
                    <h4 class="text-dark">{{ content.title }}</h4>
                    <p class="text-dark" v-html="content.abstraction"></p>
                  </template>
                  <template #p-2>
                    <m-a :href="{name:'SinglePage',params:{slug:content.slug}}">
                      <b-icon-arrow-left-circle class="h5 text-dark"/>
                    </m-a>
                  </template>
                </m-c306>
              </b-col>
            </m-single-contents-wrapper>
            <m-single-contents-wrapper content-link="header-banner-3">
              <b-col slot-scope="{content}" lg="12" class="my-3">
                <m-c306 :image="content.thumbnail" :alt="content.title" class="bg-primary header-banner-rounded py-3">
                  <template #p-1>
                    <h4 class="text-dark">{{ content.title }}</h4>
                    <p class="text-dark" v-html="content.abstraction"></p>
                  </template>
                  <template #p-2>
                    <m-a :href="{name:'SinglePage',params:{slug:content.slug}}">
                      <b-icon-arrow-left-circle class="h5 text-dark"/>
                    </m-a>
                  </template>
                </m-c306>
              </b-col>
            </m-single-contents-wrapper>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <m-section class="  ">
      <div class="container">
        <m-contents-wrapper
            slicer="4"
            contentType="page"
            :content-category="['activities']"
            :pause-if-category-not-found="true"
        >
          <b-row slot-scope="{ contents }">

            <b-col v-for="content in contents" :key="content.id" lg="3" sm="6">
              <div class="text-center">
                <m-c3>
                  <template #p1>
                    <m-a
                        class="text-dark"
                        :href="{
                        name: 'SinglePost',
                        params: { slug: content.slug },
                      }"
                    >
                      <m-img
                          :alt="content.title"
                          :src="content.thumbnail"
                          class="img-fluid"
                          style="height: 190px"
                      />
                    </m-a>
                  </template>
                  <template #p2>
                    <m-h5 class="mt-2">
                      <m-a
                          class="text-dark"
                          :href="{
                          name: 'SinglePost',
                          params: { slug: content.slug },
                        }"
                      >
                        {{ content.title }}
                      </m-a>
                    </m-h5>
                  </template>
                </m-c3>
              </div>
            </b-col>
          </b-row>
        </m-contents-wrapper>
      </div>
    </m-section>

    <b-container class="my-5">
      <m-s14 :content-category="['slide-show']" id="s14"></m-s14>
    </b-container>

    <div class="background-div my-5">
      <m-slider-101 id="slider101" class="container" first-category="جدیدترین ها"/>
    </div>


    <b-container class="my-5">
      <b-row>
        <b-col lg="3" class="header-posts-section">
          <div class="">
            <m-a :href="{ name: 'Posts' }">
              <h4 class="d-inline ml-2 text-dark text-right">آخرین مطالب
                <b-icon
                    icon="arrow-left"
                    class="latest-news-icon  text-dark"
                />
              </h4>
            </m-a>


          </div>
        </b-col>
      </b-row>
      <m-posts-300 :slicer="3" :paginate="false"/>
    </b-container>


  </SiteLayout>

</template>


<script>
import SiteLayout from "./site/SiteLayout.vue";
import Header from "@/components/Header";

export default {
  name: "Home",
  components: {
    SiteLayout,
    Header,
  },
};
</script>

<style>

#loading > div > div.p-0.m-0.container-fluid > header > div > div > div.main-menu.text-center.my-auto.col-6 > div.d-inline > button {
  background: var(--secondary) !important;
  border-radius: 50rem;
}

#loading > div > div.p-0.m-0.container-fluid > header > div > div > div.main-menu.text-center.my-auto.col-6 > div.d-inline > button > svg {
  fill: var(--primary) !important;
}

.img-custom {
  transform: rotate(180deg);
  margin-top: -3px;
}


#slider101 .see-more-link, #slider101 .custom-icon-font-size {
  color: var(--secondary) !important;
}

#slider101 .price-now {
  color: var(--dark);
}

#slider101 .btn-secondary {
  background: var(--primary) !important;
  border: 2px solid var(--secondary) !important;
  color: black !important;
}

#slider101 .btn-primary {
  background: var(--secondary) !important;
  color: white !important;
}


#s14 .gallery {
  border-radius: 10px;
}

#s14 .content * {
  color: var(--dark);
}

#s14 .content .button {
  border: 1px solid var(--dark);
}

.header-banner-image {
  height: 350px;
  object-fit: contain;
}
</style>

<style scoped>

.custom-font-size {
  font-size: 12px;
}

.background-div {
  background-color: var(--primary);
}

.latest-news-icon {
  fill: black !important;
}

.header-custom-rounded {
  border-radius: 20px;
}

.header-button-rounded {
  border-radius: 9px;
}

.header-banner-rounded {
  border-radius: 10px;
}


</style>
